import axios from "axios";
//export const baseURL = "http://localhost:3022";
export const baseURL = "https://huge-notifier.haxixu.xyz";

const instance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET",
  },
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && error.response.data.refresh) {
      try {
        await instance.get("/api/refresh");
        return instance(error.config);
      } catch (refreshErr) {
        window.location.href = "/auth/login";
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
